import React from 'react';

import { RoundedPanel } from '~/components/AiChat/SideBarDialog/components/RoundedPanel/RoundedPanel';
import { replaceDatesWithLocaleString } from '~/components/AiChat/SideBarDialog/utils';
import type { ActionTaskData, AiAction } from '~/components/AiChat/types';
import CliveMarkdownDisplay from '~/components/Clive/CliveMarkdownDisplay/CliveMarkdownDisplay';

interface ActionsPanelProps {
  action: AiAction;
  displayTitle?: boolean;
}

/**
 * A claim action's own words: what Clive proposes, and why.
 *
 * Rendered by `CliveMarkdownDisplay` rather than `MarkdownSection`, because the conductor cites its
 * sources in this text and `MarkdownSection` cannot show them: it builds an HTML string, and the
 * sanitizer drops a `src:doc:` href as an unknown scheme, so the citation reached the reader as
 * unmarked prose with the document id gone from the DOM. It also brings the explanation's tables
 * and spacing in line with every other surface that renders Clive's markdown.
 */
export const GeneralActionInner: React.FC<ActionsPanelProps> = ({ action, displayTitle = true }) => {
  const { task_text: taskText, explanation } = action.task_data as ActionTaskData;

  return (
    <RoundedPanel variant="clear">
      {displayTitle && taskText ? (
        <CliveMarkdownDisplay content={replaceDatesWithLocaleString(taskText)} className="text-sm" />
      ) : null}
      {explanation ? (
        <CliveMarkdownDisplay content={replaceDatesWithLocaleString(explanation)} className="text-sm" />
      ) : null}
    </RoundedPanel>
  );
};
